import React, {Component} from 'react';
import { Modal, Button, Col } from 'react-bootstrap';
import config from '../../config/config';
import { FaWhatsapp, FaExternalLinkAlt } from "react-icons/fa";
import { AiOutlineCopy } from "react-icons/ai";
import './WhatsappModal.css'
import AutoDismissAlert from '../auto_dismiss_alert/AutoDismissAlert';
import { connect } from "react-redux";
import { textHelper } from '../../helpers/text'
import { ReactComponent as CloseIcon } from '../../resources/images/close.svg';

class WhatsappModal extends Component {
    CAMERA_BUTTON = 1;
    ACCEPT_BUTTON = 2;
    RELOAD_BUTTON = 3;
    RELOAD_AND_ADVANCE_BUTTON = 4;
    SUPPORT_BUTTONS = 5;

    constructor(props) {
        super(props);
        this.state = { alert: null };
    }

    handleClick = () => {
        const textToCopy = config.whatsappNumber;
        navigator.clipboard.writeText(textToCopy).then(() => {
            this.showAlert('success', 'Copiado exitosamente')
        }).catch((err) => {
            this.showAlert('danger', 'Error al copiar')
        });
    };

    showAlert = (type, message) => {
        this.setState({
          alert: { type, message },
        });
      };
    
    handleAlertClose = () => {
        this.setState({ alert: null });
    };

    generateWhatsappLink = () => {
        let message = config.customerServiceWelcomeMessage
        const { errorMessage } = this.props;
        const showProblem = errorMessage && errorMessage.button === this.SUPPORT_BUTTONS;
        if (showProblem) {
            message += `\n- Problema: Intentos fallidos lectura de cédula`;
        }
        if (this.props.code) {
            message += `\n- Código de Firma: ${this.props.code}`
        }
        if (this.props.rut) {
            message += `\n- RUT: ${textHelper.formatRut(this.props.rut)}`
        }
        if (this.props.plate) {
            message += `\n- Patente: ${this.props.plate}`
        }
        return textHelper.createWhatsAppLink(config.whatsappNumber, message)
    }

    handleClickWhatsapp = () => {
        const whatsappLink = this.generateWhatsappLink()
        window.open(whatsappLink, "_blank");
    }
    
    render(){
        const { handleClose } = this.props
        const customerServiceHours = config.customerServiceHours;
        const { errorMessage } = this.props;
        const shouldShowPrincipalMessage = errorMessage &&
                                   errorMessage.principalMessage &&
                                   errorMessage.button === this.SUPPORT_BUTTONS;

        return (
        <div>
            <Modal
                show={this.props.show}
                onHide={handleClose}
                className="whatsapp-modal"
            >
                <Modal.Header className="v-center">
                    <Col xs={1} className="p-0">
                        <FaWhatsapp size={28} color="#25D366"/>
                    </Col>
                    <Col xs={9} style={{paddingLeft: 12, paddingRight: 12}}>
                        <Modal.Title>
                            Contactar por WhatsApp
                        </Modal.Title>
                    </Col>
                    <Col xs={2} className="p-0" style={{textAlign: "end"}}>
                        <CloseIcon onClick={handleClose} size={22} color="#595959"/>
                    </Col>
                </Modal.Header>
                <Modal.Body>
                <p>
                {shouldShowPrincipalMessage
                    ? errorMessage.principalMessage
                    : "Contáctanos por WhatsApp para recibir asistencia directa de nuestro equipo de soporte."}
                </p>
                    <p>
                        <b>Número:</b> {config.whatsappNumber}
                    </p>
                    <p>
                        {customerServiceHours}
                    </p>
                    
                </Modal.Body>
                <Modal.Footer style={{textAlign: 'center'}}>
                    <Button variant="primary" onClick={this.handleClickWhatsapp} className="whatsapp-button">
                        Ir a WhatsApp
                        <FaExternalLinkAlt className="icon-spacing-left" size={16}/>
                    </Button>
                    <br/>
                    <br/>
                    <Button variant="primary" onClick={this.handleClick} className="copy-button">
                        Copiar número
                        <AiOutlineCopy className="icon-spacing-left" size={16}/>
                    </Button>
                </Modal.Footer>
            </Modal>

            {this.state.alert && (
            <AutoDismissAlert
                type={this.state.alert.type}
                message={this.state.alert.message}
                onClose={this.handleAlertClose}
            />
            )}
        </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        code: state.code,
        rut: state.rut,
        plate: state.plate,
        errorMessage: state.errorMessage,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatsappModal);